import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=78c4d3cf&scoped=true&"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=78c4d3cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4d3cf",
  null
  
)

export default component.exports